import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@ublend-npm/react-tooltip';
import SearchIcon from '@material-ui/icons/Search';
import NotificationsIcon from '@material-ui/icons/Notifications';
import HelpIcon from '@material-ui/icons/Help';
import NavBar from '@ublend-npm/aulaui-next-web/NavBar';
import Avatar from '@ublend-npm/aulaui-next-web/Avatar';

import { IconButton, HelpButton, AvatarContainer } from './UserBar.styled';
import Zendesk from '../../Zendesk/Zendesk';
import Intercom from '../../Intercom/Intercom.container';
import NotificationsDialog from '../../NotificationsDialog';
import Badge from '../../common/Badge';

const UserBarWrapper = ({
  onSearchClick,
  onHelpClick,
  onAvatarClick,
  onNotificationsClick,
  avatarName,
  avatarSrc,
  hasUnreadNotifications,
}) => {
  const notificationsButton = (
    <IconButton
      onClick={onNotificationsClick}
      size="medium"
      label="Notifications"
      type="transparent"
      icon={NotificationsIcon}
    />
  );
  const wrappedNotificationsButton = hasUnreadNotifications ? (
    <Badge size="small">{notificationsButton}</Badge>
  ) : (
    notificationsButton
  );

  return (
    <NavBar
      role="region"
      aria-label="user bar"
      bottomDecoration={
        <Tooltip title="Help" space={4} position="right">
          <HelpButton
            onClick={onHelpClick}
            size="medium"
            label="help"
            icon={HelpIcon}
            type="transparent"
          />
        </Tooltip>
      }
    >
      <Tooltip title="My profile" space={4} position="right">
        <AvatarContainer
          onClick={onAvatarClick}
          role="button"
          aria-label="My profile"
          onKeyPress={(e) => e.key === 'Enter' && onAvatarClick()}
          tabIndex={0}
        >
          <Avatar name={avatarName} src={avatarSrc} size="large" />
        </AvatarContainer>
      </Tooltip>
      <Tooltip title="Search" space={4} position="right">
        <IconButton
          onClick={onSearchClick}
          size="medium"
          label="Search"
          type="transparent"
          icon={SearchIcon}
        />
      </Tooltip>
      <Tooltip title="Notifications" space={4} position="right">
        {wrappedNotificationsButton}
      </Tooltip>

      {!window.Cypress && [<Zendesk />, <Intercom />]}
      <NotificationsDialog />
    </NavBar>
  );
};

UserBarWrapper.defaultProps = {
  avatarName: '',
  avatarSrc: '',
  hasUnreadNotifications: false,
};

UserBarWrapper.propTypes = {
  avatarName: PropTypes.string,
  avatarSrc: PropTypes.string,
  hasUnreadNotifications: PropTypes.bool,
  onHelpClick: PropTypes.func.isRequired,
  onAvatarClick: PropTypes.func.isRequired,
  onSearchClick: PropTypes.func.isRequired,
  onNotificationsClick: PropTypes.func.isRequired,
};

export default React.memo(UserBarWrapper);
